import React from 'react';
import PropTypes from 'prop-types';
import CancelView from './CancelView';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Collapse } from 'reactstrap';
import {apiRequest} from '../../utils/request';
import ReactSwipe from 'react-swipe';
import moment from 'moment';
import PickupSkipView from  './PickupSkipView';
import {Aux, BASE_URL, IsCordovaApp, IsNullOrUndefined} from "../../constants";
import {push, navigate} from "../../utils/navigation";
import store from '../../store';
import PickupStatus from "../DriverRuns/PickupStatus";
import SelectReceiptModal from "../Common/SelectReceiptModal";
import { mustBeArray } from '../../utils/lib';
import {getCollectionAction, getRunFlag, getRunFlagBadgeClass, getRunFlagIcon, getRunTypeCardStyle} from "../../utils/collectionTypes";

class Pickup extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      run: props.run,
      pickup: props.pickup,
      isNoteView: false,
      isCancelView: false,
      cancelNoteItems: [],
      modal: false,
      images: [],
      currentImage: '',
      isOpen: props.pickup.pickupStatusCode != 'COM',
      isManualOpen: false,
      tankId: null,
      receiptModalOpen: false,
      receiptModalTank: null,
    };
    this.enterCancelNote = this.enterCancelNote.bind(this);
    this.enterCancel = this.enterCancel.bind(this);
    this.enterNote = this.enterNote.bind(this);
    this.noteCancelLeave = this.noteCancelLeave.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleIsOpen = this.toggleIsOpen.bind(this);
    this.openReceiptModal = this.openReceiptModal.bind(this);
    this.closeReceiptModal = this.closeReceiptModal.bind(this);
    this.handleSelectReceipt = this.handleSelectReceipt.bind(this);
  }

  openReceiptModal(tank) {
    // Refresh receipts as the picker opens so newly-arrived receipts show without a page reload.
    if (this.props.onRefreshReceipts) {
      this.props.onRefreshReceipts();
    }
    this.setState({ receiptModalOpen: true, receiptModalTank: tank });
  }

  closeReceiptModal() {
    this.setState({ receiptModalOpen: false, receiptModalTank: null });
  }

  handleSelectReceipt(receipt) {
    const tank = this.state.receiptModalTank;
    this.setState({ receiptModalOpen: false, receiptModalTank: null }, () => {
      if (tank && this.props.onSelectReceipt) {
        // Fills the litres, backfills the receipt's context, and ticks the tank — exactly
        // as if the driver had typed the value and confirmed it.
        this.props.onSelectReceipt(receipt, this.state.pickup, tank);
      }
    });
  }

  componentWillReceiveProps(nextProps){
    let isOpen = this.state.isManualOpen || nextProps.pickup.pickupStatusCode != 'COM' || this.props.selected;

    this.setState({
      run: nextProps.run,
      pickup: nextProps.pickup,
      isOpen,
      tankId: nextProps.tankId
    });

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevState.tankId !== this.state.tankId){
      let {pickup} =  this.state;
      let tank = pickup.pickupTanks.filter(x => x.tankID===this.state.tankId);
      if(tank.length === 1){
        this.setState({
            isOpen: true,
            isManualOpen: true},
          () => this.props.onStartPickup(this.state.pickup));
      }
    }
  }

  toggle() {
    let isOpening = !this.state.modal;
    this.setState({images: [], currentImage: ''});
    if(isOpening){
      apiRequest(`/api/runs/pickupImages?locationId=${this.state.pickup.locationID}&isDelivery=${this.state.run && (this.state.run.truckCollectionTypeCode === 'BD' || this.state.run.truckCollectionTypeCode === 'BIBD')}`)
        .then(x => {
          let images = x.data.map(i => `data:image/jpeg;base64,${i.image}`);
          this.setState({images, currentImage: images.length > 0 ? images[0] : ''});
        });
    }

    this.setState({
      modal: !this.state.modal
    });
  }

  enterCancel(){
    this.enterCancelNote(['Truck full', 'No car parking', 'No access', 'Can\'t find equipment', 'Shop closed', 'Tank swap asap'], false, true);
  }

  enterNote(){
    this.enterCancelNote(['Please phone','Tank needs', 'Please organise a key/ card'], true, false);
  }

  enterCancelNote(reasonItems, isNote, isCancel){
    let reasons = new Set(reasonItems);
    if(this.state.pickup.cancelReason != null){
      reasons.add(this.state.pickup.cancelReason);
    }

    this.setState({
      isNoteView: isNote,
      isCancelView: isCancel,
      cancelNoteItems: reasons
    });
  }

  noteCancelLeave(evnt){
    evnt.preventDefault();
    this.setState({
      isNoteView: false,
      isCancelView: false,
    });
  }

  toggleIsOpen(evnt){
    evnt.preventDefault();
    let isOpen = !this.state.isOpen;

    if(this.state.pickup.pickupStatusCode=='COM') {
      this.setState({isOpen: isOpen, isManualOpen: isOpen});
    }
  }


  render() {
    let { onMapLocation, onLocationCheckin,
      onResetRoute, onCancelReason,
      onInputTank, onInputTin,  isReadOnly
    } = this.props;
    let {run, pickup} = this.state;
    let runId = run.id;

    let handleFocus = function(e) {
      let target = e.target;
      setTimeout(function() {
        target.select();
      }, 0);
    };

    let previousComplete = ()=> {
      return true;
      /*let isComplete = false;
      for(let i = 0; i < run.pickups.length; i++){
        if(run.pickups[i].id==pickup.id){
          break;
        }
        isComplete = run.pickups[i].pickupStatusCode != 'PEN';
      }
      return isComplete;*/
    };


    let inputTanksView = (pickup) => {
      let tanks = pickup.pickupTanks;

      if(!run.isBaseCheckedIn || (run.isComplete && !this.props.isAdmin) || isReadOnly){
        return null;
      } else if(!pickup.isBase && !previousComplete()){
        return (<div><h4>You must complete all locations prior to complete this location</h4></div>);
      }
      else {
        return (
          <div>
            {tanks.map(tank => {

              let isSelectedTank = this.props.tankId === tank.tankID;
              let isDisabled = !this.props.selected;
              if(!isSelectedTank && this.props.tankId > 0){
                isDisabled = true;
              }

              let isDropOff = tank.requiresDropOff;
              let isPickup = tank.requiresPickup || tank.isPickedUp;

              return (
                <div className="row form-group form-inline" key={tank.id}>
                  { isDropOff && <div className="row">
                    <div className="col-12">
                      <h4 className={`text-${tank.driverEstimatedLitresPickedUp > 0 ? 'success': 'danger'}`}>
                        <i
                            className={"fa fa-plus-square text-danger mr-1"}
                            data-toggle="tooltip" data-placement="top" title="Pickup this tank"
                        />#{tank.tankID} drop off</h4>
                    </div>
                  </div> }
                  { isPickup && <div className="row">
                    <div className="col-12">
                      <h4 className={`text-${tank.isPickedUp ? 'success': 'danger'}`}>
                        <i
                            className={"fa fa-minus-square text-danger mr-1"}
                            data-toggle="tooltip" data-placement="top" title="Drop off this tank"
                        />#{tank.tankID} {tank.isPickedUp ? 'picked up': 'pickup'}                        
                      </h4>
                    </div>
                  </div> }
                  
                  <div className="col-md-12 col-xs-12 input-group">
                    { (tank.latitude !== null && tank.longitude !== null) ?
                      <a className="input-group-addon"
                         href={`http://maps.google.com/maps?&z=21&q=${tank.latitude}+${tank.longitude}`}
                         target={'_blank'}>{`#${tank.tankID} - ${tank.tankCapacityLitres}L`}</a> :
                      <span className="input-group-addon">{`#${tank.tankID} - ${tank.tankCapacityLitres}L`}</span> }
                    <input className="form-control"
                           type="number"
                           disabled={isDisabled}
                           onChange={(evnt) => onInputTank(evnt, runId, pickup.id, tank.id)}
                           placeholder="Picked up"
                           value={tank.driverEstimatedLitresPickedUp == null ? 0 : tank.driverEstimatedLitresPickedUp}
                           onFocus={handleFocus}
                    />
                    { isDisabled && <a className="input-group-addon" style={{float: 'right'}} href={`${BASE_URL}/qr/lookuprun/?runId=${pickup.runId}&pickupId=${pickup.id}&action=startPickup`} onClick={(e) => { e.preventDefault(); navigate(`${BASE_URL}/qr/lookuprun/?runId=${pickup.runId}&pickupId=${pickup.id}&action=startPickup`); }}><i className="fa fa-2x fa-qrcode" /></a> }
                    { !isDisabled && <a className="input-group-addon" style={{float: 'right'}} href={''} title="Select a receipt"
                                        onClick={(e) => { e.preventDefault(); this.openReceiptModal(tank); }}
                    ><i className="fa fa-2x fa-file-text-o btn btn-info" /></a> }
                    { !isDisabled && <a className="input-group-addon" style={{float: 'right'}} href={''}
                                        onClick={(e) => {
                                          e.preventDefault();

                                          this.setState({
                                            isNoteView: false,
                                            isCancelView: false,
                                            isManualOpen: false,
                                          }, ()=> {
                                            this.props.onCompletePickup({...pickup, pickedupTankId: tank.tankID});
                                            store.dispatch(push(`${BASE_URL}/runs/search/${run.id}/locations/${pickup.locationID}`));
                                          });

                                        }}
                    >
                      <i className="fa fa-2x fa-check btn btn-success" /></a> }
                  </div>
                </div>
              );
            })}
          </div>);
      }
    };

    let inputTinsView = (pickup) => {
      if(!run.isBaseCheckedIn || (run.isComplete && !this.props.isAdmin) || isReadOnly){
        return null;
      }
      else if(pickup.isTinLocation && !pickup.isBase && !previousComplete()){
        return (<div><h4>You must complete all locations prior to complete this location</h4></div>);
      }
      else {
        if (pickup.isTinLocation) {
          let hasValue = pickup.numberOfTinsCollected != null && pickup.numberOfTinsCollected > 0;
          return (
            <div className="row form-group form-inline">
              <div className="col-md-8 input-group">
                <span className="input-group-addon">Expected Tins: {pickup.expectedTins}</span>
                <input className="form-control"
                       type="number"
                       disabled={!this.props.selected}
                       onChange={(evnt) => onInputTin(evnt, runId, pickup.id)}
                       placeholder="Picked up"
                       value={pickup.numberOfTinsCollected == null ? 0 : pickup.numberOfTinsCollected}
                       onFocus={handleFocus}
                />
              </div>
              <div className="col-md-">
                {/* <button type="button" className={hasValue ? "btn btn-success" : "btn btn-primary"}
                        onClick={(evnt) => onPickupTin(evnt, runId, pickup.id)}>
                  Pickup
                </button> */}
              </div>
            </div>
          );
        } else {
          return null;
        }
      }
    };

    let checkInView = () => {
      if(isReadOnly){
        return null;
      }
      else if(pickup.isCheckIn && !run.isBaseCheckedIn){
        return (
          <div className="row">
            <div className="col-md-8">&nbsp;</div>
            <div className="col-md-4">
              <button type="button" className="btn btn-primary" onClick={() => onLocationCheckin(runId, pickup.id, 'Complete')}>Check-in</button>
            </div>
          </div>);
      } else {
        return null;
      }
    };
    let checkOutView = () => {
      if(pickup.isCheckOut && run.isBaseCheckedIn && !run.isBaseCheckedOut && run.isAllNonBaseComplete){
        return (
          <div className="row">
            <div className="col-md-8">&nbsp;</div>
            <div className="col-md-4">
              <button type="button" className="btn btn-primary" onClick={() => onLocationCheckin(runId, pickup.id, 'Complete')}>Check-out</button>
            </div>
          </div>);
      } else {
        return null;
      }
    };

    let nextPreviousView = ()=>{
      let next = pickup.isCheckOut ? null : pickup.pickupOrder + 1;
      let previous = pickup.isCheckIn ? null : pickup.pickupOrder - 1;

      let nextPickup = next == null ? null : run.pickups.filter(p => p.pickupOrder == next);
      let previousPickup = previous == null ? null : run.pickups.filter(p => p.pickupOrder == previous);

      return (
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <div className="pull-left">
              <div className="input-group">
                {previousPickup &&
                <span className="input-group-btn" style={{minHeight: '35px'}}>
                <button onClick={(evnt) => onMapLocation(previousPickup[0], evnt, 'pickup')} className="btn btn-info">
                  <i className="fa fa-backward" />&nbsp;
                </button>
              </span>}
                <span className="input-group-btn" style={{minHeight: '35px'}}>
              <button onClick={(evnt) =>
              {
                if(IsCordovaApp()){
                  window.open(`geo://0,0?q=${pickup.locationLatitude},${pickup.locationLongitude}(${encodeURI(pickup.clientCompanyName)})`, '_system', 'location=yes');
                } else {
                  window.open(`https://www.google.com/maps/dir/?api=1&destination=${pickup.locationLatitude},${pickup.locationLongitude}&travelmode=driving`, '_blank');
                }
              }}

                 className="btn btn-info">
                <i className="fa fa-truck" />
              </button>
            </span>
              </div>
            </div>
            <div className="pull-right">
              <div className="input-group">
            <span className="input-group-btn" style={{minHeight: '35px'}}>
              <button onClick={(evnt) => onResetRoute(evnt)} className="btn btn-info">
                <i className="fa fa-th" />
              </button>
            </span>
                {nextPickup &&
                <span className="input-group-btn" style={{minHeight: '35px'}}>
              <button onClick={(evnt) => onMapLocation(nextPickup[0], evnt, 'pickup')}
                      className="btn btn-info">
              &nbsp;<i className="fa fa-forward" />
              </button>
            </span>}
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (<div className="container" style={{marginLeft: null, paddingLeft: null, paddingRight: null, ...getRunTypeCardStyle(run.truckCollectionTypeCode)}}>
      <div className="row">
        <div className="col-md-12 col-xs-12" onClick={this.toggleIsOpen}>
          <PickupStatus pickup={pickup} run={run} />
          <span className={getRunFlagBadgeClass(run.truckCollectionTypeCode) + ' ml-1'} style={{fontSize: '75%'}}>
            <i className={getRunFlagIcon(run.truckCollectionTypeCode)}/> {getRunFlag(run.truckCollectionTypeCode)}
          </span>
          {!pickup.isBase && (
            <h6 className="text-muted">{getCollectionAction(run.truckCollectionTypeCode)} <span className="badge badge-info">{pickup.volume ? pickup.volume : 'O L'}</span> <span className="badge badge-info">{pickup.numTanks}</span><br /></h6>
          )}
          {!pickup.isBase && (
            <h6 className="text-muted">Expected <span className="badge badge-info">{pickup.expectedVolumeRaw}</span></h6>
          )}
          <h5 style={{marginTop: 10}}>{pickup.clientCompanyName}</h5>
          {pickup.locationNotes && (<h6><i className="fa fa-book" />&nbsp;&nbsp;{pickup.locationNotes}</h6>)}
          {pickup.pickupNote && pickup.pickupNote != '' && (<h6><i className="fa fa-book" />&nbsp;&nbsp;{pickup.pickupNote}</h6>)}
        </div>
      </div>
      <div className="row">
        <div className="col-9">
          <h6><a href={`http://maps.google.com/maps?&z=21&q=${pickup.locationLatitude}+${pickup.locationLongitude}`}
                 target={'_blank'}>{`${pickup.locationLatitude}, ${pickup.locationLongitude}`}</a></h6>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 col-xs-12">
          <i className="icon-location-pin" />&nbsp;
          { IsCordovaApp() ?
            <a href={`geo://0,0?q=${pickup.locationLatitude},${pickup.locationLongitude}(${encodeURI(pickup.clientCompanyName)})`}
               target="_system" data-rel="external">{pickup.locationFullAddress}</a>
          :
            <a href={`https://maps.google.com/maps?saddr=Current+Location&daddr=${pickup.locationLatitude},${pickup.locationLongitude}&mode=driving`}
               target="_blank">{pickup.locationFullAddress}</a>
          }
        </div>
      </div>
      <div className="row">&nbsp;</div>
      {nextPreviousView()}
      <Collapse isOpen={this.state.isOpen}>
      <div className="row">&nbsp;</div>
      <div className="row">
        <div className="col-md-12 col-xs-12">
          <i className="icon-map" />&nbsp;
          <a href="#"
             className="card-link"
             onClick={(evnt) => onMapLocation(pickup, evnt, 'pickup')}>Show on route map</a>
        </div>
      </div>
      <div className="row">&nbsp;</div>
      {mustBeArray(pickup.locationContacts).map(x => {
        return (
          <div className="row" key={x.id}>
            <div className="col-md-12 col-xs-12"><strong><i className="fa fa-male" />&nbsp;&nbsp;</strong><span style={{marginRight: '10px'}}>{x.fullName}</span>
              {mustBeArray(x.communications).filter(y => y.communicationType.toLowerCase().includes('phone')).map(c => {
                return (
                  <a key={c.id} href={`tel:${c.detail}`} style={{marginRight: '10px'}}><strong><i className="fa fa-phone" />&nbsp;</strong>{c.detail}</a>
                );
              })}
            </div>
          </div>
        );
      })}
      {mustBeArray(pickup.locationCommunications).filter(y => y.communicationType.toLowerCase().includes('phone')).map(x => {
        return (
          <div className="row" key={x.id}>
            <div className="col-md-12 col-xs-12"><a href={`tel:${x.detail}`}><strong><i className="fa fa-phone" />&nbsp;&nbsp;</strong>{x.detail}</a></div>
          </div>
        );
      })}
      {/* Display photos uploaded by driver */}
      <div className="flex flex-wrap mb-1">
          {
              mustBeArray(pickup.attachments).map((image,i) => {
                  return(
                      <div className="mb-1 pl-1 pr-1 mt-2" key={i}>
                          <div><img src={image.blobUri || image.fileContents} key={i} width="285px" height="100%" className="mb-q"/></div>
                          <div className="mr-q float-left" style={{width: "270px",textOverflow: "ellipsis", overflow: "clip"}}>
                              {image.fileName}
                          </div>
                          <div className="clearfix"/>
                      </div>
                  );
              })
          }
      </div>
      {pickup.locationTypeCode != 'B' && pickup.locationTypeCode != 'D' && (<div className="row">&nbsp;</div>)}
      {checkInView()}
      {checkOutView()}
      {inputTanksView(pickup)}
      {inputTinsView(pickup)}
      {run.isBaseCheckedIn && <CancelView
        pickup={pickup}
        enterNote={this.enterNote}
        enterCancel={this.enterCancel}
        isCancelView={this.state.isCancelView}
        isNoteView={this.state.isNoteView}
        reasons={this.state.cancelNoteItems}
        onCancelReason={onCancelReason}
        run={this.state.run}
        onLocationAddNote={(e, runId, pickupId) => {
          this.noteCancelLeave(e);
        }}
        onLocationCancel={(e, runId, pickupId) => {
          this.noteCancelLeave(e);
          this.props.onCompletePickup(pickup, true);
        }}
        noteCancelLeave={this.noteCancelLeave}
        isReadOnly={isReadOnly || !this.props.selected}
      /> }

      {(pickup.locationImageCount > 0 && !this.props.showImages) &&
      <div className="row">
        <div className="col-md-12 col-xs-12">
          Images not available in run preview ({pickup.locationImageCount} image(s))
        </div>
      </div>
      }

        {pickup.notes.length > 0 &&
        <Aux>
          <div className={"row"}><div className={"col-12"}><h5>Pickup Notes</h5></div></div>
          { pickup.notes.map(note => (<div className={"row"} key={note.id}>
            <div className={"col-12"}>
              <a href={`#note_detail_${note.id}`}
                 aria-expanded="false"
                 aria-controls={`note_detail_${note.id}`}
                 data-toggle="collapse">{note.noteText}</a></div>

            <div className="collapse col-12" id={`note_detail_${note.id}`}>
              <div className={"row"}>
                <div className={"col-12"}>{note.updatedBy}</div>
              </div>
              <div className={"row"}>
                <div className={"col-12"}>{moment(note.createdDate).format('DD/MM/YYYY LT')}</div>
              </div>
            </div>
          </div>)) }
          <div className="mb-0">&nbsp;</div>
        </Aux>
        }
      

      {(pickup.locationImageCount > 0 && this.props.showImages) &&
      <div className="row">
        <div className="col-md-12 col-xs-12">
          <Button onClick={this.toggle} color="info"><i className="fa fa-picture-o" /> Show images</Button>
          <Modal isOpen={this.state.modal}
                 toggle={this.toggle}
                 className={this.props.className}
                 zIndex={10000000000}>
            <ModalBody>
              { this.state.currentImage != '' &&
                <ReactSwipe className="carousel" swipeOptions={{continuous: true}} ref="swipe">
                  { this.state.images.map(i => {return (
                    <div key={i}><img className="d-block img-fluid w-100"
                        src={i} /></div>);})}
                </ReactSwipe>
              }
              {this.state.currentImage == '' && <h4><i className="fa fa-cog fa-spin" /></h4>}
            </ModalBody>
            <ModalFooter>
              <div className="row">
                <div className="col-md-12 col-xs-12">
                {
                  this.state.images.map((i, index) => {
                  return (
                      <img src={i} className="img-thumbnail w-25" key={i}
                               onClick={(e) => this.refs.swipe.slide(index)}
                      />
                    );
                })}
              </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xs-12">
                <Button color="secondary" onClick={this.toggle}>Close</Button>
              </div>
              </div>
            </ModalFooter>
          </Modal>
        </div>
      </div>}

      { (!run.isBaseCheckedIn || (run.isComplete && !this.props.isAdmin) || isReadOnly || pickup.isCheckIn || pickup.isCheckOut || this.state.isCancelView) ? null :
        <div className="row" style={{marginTop: '5px', marginBottom: '5px'}}>
          <div className="col-md-12 col-xs-12" style={{textAlign: 'right'}}>
            { this.props.selected ?
              <div>
                <button style={{marginRight: '5px'}} className={'btn btn-primary'} onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    isNoteView: false,
                    isCancelView: false,
                    isManualOpen: false,
                  }, ()=> {
                    this.props.onCompletePickup(pickup);
                    if(this.props.tankId > 0){
                      store.dispatch(push(`${BASE_URL}/runs/search/${run.id}/locations/${pickup.locationID}`));
                    }
                  });
                }}>Complete Pickup</button>
                <button className={'btn btn-default'} onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    isNoteView: false,
                    isCancelView: false,
                  }, ()=> {
                    this.props.onCancelPickup(pickup);
                    if(this.props.tankId > 0){
                      store.dispatch(push(`${BASE_URL}/runs/search/${run.id}/locations/${pickup.locationID}`));
                    }
                  });
                }}>Cancel Edit</button>
              </div>
              :
              <div><button className={'btn btn-primary'} onClick={(e) => {
                e.preventDefault();
                this.setState({isOpen: true, isManualOpen: true}, ()=> this.props.onStartPickup(pickup));
              }}>{pickup.pickupStatusCode === 'PEN' ? 'Start Pickup' : 'Edit Pickup'}</button>
              </div> }
          </div>
        </div>
      }

      {!pickup.isBase && pickup.pickupStatusCode == 'PEN' && pickup.locationImageCount > 0 && <div className="row">&nbsp;</div> }
      {!pickup.isBase && pickup.pickupStatusCode == 'PEN' &&
      <div className="row">
        <div className="col-md-12 col-xs-12">
          <PickupSkipView pickup={pickup} run={run} onFinished={this.props.onFinishSkipEdit} />
        </div>
      </div>}
      {!pickup.isBase && <div className="row">&nbsp;</div> }
      {!pickup.isBase && (
        <div className="row">
          <div className="col-md-12 col-xs-12 font-weight-bold">
            Total <span className="badge badge-info">{`${parseFloat(run.totalEstimatedLitresPickedUp).toFixed(2)} L `}</span>&nbsp;from&nbsp;
            <span className="badge badge-info">{ `${run.pickupsComplete}/${run.pickupsToComplete}`}</span> locations Capacity <span className="badge badge-info">{ `${parseFloat(run.truckCapacity).toFixed(0)} L`}</span>
          </div>
        </div>
      )}
      </Collapse>
      <SelectReceiptModal
        isOpen={this.state.receiptModalOpen}
        toggle={this.closeReceiptModal}
        receipts={this.props.unassignedReceipts}
        assignedReceipts={(this.props.allReceipts || []).filter(r => r.tankId && r.pickupId === this.state.pickup.id)}
        loading={this.props.receiptsLoading}
        tankLabel={this.state.receiptModalTank ? `#${this.state.receiptModalTank.tankID}` : null}
        onSelect={this.handleSelectReceipt}
        onUnassign={(receipt) => this.props.onUnassignReceipt && this.props.onUnassignReceipt(receipt.id)}
        onManualEntry={this.closeReceiptModal}
      />
    </div>);
  }
}

Pickup.propTypes = {
  onFinishSkipEdit: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  showImages: PropTypes.bool.isRequired,
  onStartPickup: PropTypes.func.isRequired,
  onCompletePickup: PropTypes.func.isRequired,
  onCancelPickup: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  tankId: PropTypes.number,
  unassignedReceipts: PropTypes.array,
  allReceipts: PropTypes.array,
  receiptsLoading: PropTypes.bool,
  onSelectReceipt: PropTypes.func,
  onUnassignReceipt: PropTypes.func,
  onRefreshReceipts: PropTypes.func,
};

Pickup.defaultProps = {
  showImages: true,
  unassignedReceipts: [],
};

export default Pickup;
